import {ModuleController} from "../../../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../../../infrastructure/domain-services/base-managed-service";
import {GameCenterIndexPageConfig} from "./game-center.index-page.config";
import {GameCenterIndexPageHandlers} from "./handlers/game-center.index-page.handlers";
import {GameCenterIndexPageStore} from "./game-center.index-page.store";


export class GameCenterIndexPageController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, GameCenterIndexPageConfig, GameCenterIndexPageStore, GameCenterIndexPageHandlers];

}
